import { render } from "./OnDemand.vue?vue&type=template&id=ef256a94&scoped=true"
import script from "./OnDemand.vue?vue&type=script&lang=js"
export * from "./OnDemand.vue?vue&type=script&lang=js"

import "./OnDemand.vue?vue&type=style&index=0&id=ef256a94&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef256a94"]])

export default __exports__